var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "affixDoc" },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "demo-ruleForm",
          attrs: {
            model: _vm.item,
            "status-icon": "",
            "label-width": _vm.labelWidth,
          },
        },
        [
          _c("el-form-item", { attrs: { prop: "pass" } }, [
            _c(
              "span",
              {
                staticClass: "label-wrap",
                attrs: { slot: "label", alt: _vm.name, title: _vm.name },
                slot: "label",
              },
              [
                _vm.isStar
                  ? _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")])
                  : _vm._e(),
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.item.hideLable
                        ? ""
                        : _vm.name
                        ? _vm.name + "："
                        : "附件信息："
                    ) +
                    " "
                ),
              ]
            ),
            _c("p", { staticStyle: { position: "relative", width: "100%" } }, [
              _vm._v(_vm._s(_vm.item.name)),
            ]),
            _c(
              "label",
              {
                staticClass: "upload",
                style: { width: _vm.show ? "120px" : "80px" },
              },
              [
                _c("em", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: this.item.filePath,
                      expression: "this.item.filePath",
                    },
                  ],
                  staticClass: "el-icon-view",
                  on: {
                    click: function ($event) {
                      return _vm.fileView(_vm.item)
                    },
                  },
                }),
                _c("em", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: this.item.filePath,
                      expression: "this.item.filePath",
                    },
                  ],
                  staticClass: "el-icon-download",
                  staticStyle: { "margin-left": "10px" },
                  on: {
                    click: function ($event) {
                      return _vm.fileDownload(_vm.item)
                    },
                  },
                }),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.IsShow(_vm.item) && _vm.filingCBtn,
                        expression: "IsShow(item)&&filingCBtn",
                      },
                    ],
                    staticClass: "qianzhang",
                    on: {
                      click: function ($event) {
                        return _vm.qianFn(_vm.item.filePath)
                      },
                    },
                  },
                  [_vm._v("签章")]
                ),
              ]
            ),
          ]),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.imgDialogVisible,
            modal: _vm.showModal,
            width: "740px",
            height: "100%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.imgDialogVisible = $event
            },
            closed: _vm.dialogClose,
          },
        },
        [
          _c("img", {
            staticClass: "viewImg",
            attrs: { src: _vm.filePath, alt: "" },
            on: {
              contextmenu: function ($event) {
                $event.preventDefault()
              },
            },
          }),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.pdfDialogVisible,
            height: "100%",
            top: "8vh",
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.pdfDialogVisible = $event
            },
            closed: _vm.dialogClose,
          },
        },
        [
          _c("iframe", {
            attrs: {
              src: _vm.pdfViewer + this.filePath + "?range=true",
              frameborder: "0",
              height: "600",
              width: "100%",
            },
            on: {
              contextmenu: function ($event) {
                $event.preventDefault()
              },
            },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }